import axios from './index'
const origin = '/co/guide/'


const listGuides = () => {
    return new Promise(resolve => {
        axios.get(origin + 'listGuides').then(res => resolve(res))
    })
}

const listAllGuides = () => {
    return new Promise(resolve => {
        axios.get(origin + 'ListAllGuides').then(res => resolve(res))
    })
}

const loadGuideList = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'loadGuideList', param).then(res => resolve(res))
    })
}
const lookGuide = (id) => {
    return new Promise(resolve => {
        axios.post(origin + 'LookGuide', id).then(res => resolve(res))
    })
}


const addGuide = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'addGuide', param).then(res => resolve(res))
    })
}
//修改
const updateGuide = param => {
    return new Promise(resolve => {
        axios.post(origin + 'UpdateGuide', param).then(res => resolve(res))
    })
}
//
const enableGuid = param => {
    return new Promise(resolve => {
        axios.post(origin + 'EnableGuid', param).then(res => resolve(res))
    })
}
const disableGuid = param => {
    return new Promise(resolve => {
        axios.post(origin + 'disableGuid', param).then(res => resolve(res))
    })
}
const relieveGuid = param => {
    return new Promise(resolve => {
        axios.post(origin + 'relieveGuid', param).then(res => resolve(res))
    })
}
const selectIDNumber = param => {
    return new Promise(resolve => {
        axios.post(origin + 'selectIDNumber', param).then(res => resolve(res))
    })
}

const guideBand = param => {
    return new Promise(resolve => {
        axios.post(origin + 'guideBand', param).then(res => resolve(res))
    })
}

const cancelGuid = param => {
    return new Promise(resolve => {
        axios.post(origin + 'cancelGuid', param).then(res => resolve(res))
    })
}

const listGuidesByTime = param => {
    return new Promise(resolve => {
        axios.post(origin + 'ListGuidesByTime', param).then(res => resolve(res))
    })
}


export default {
    listGuides,
    listAllGuides,
    loadGuideList,
    lookGuide,
    addGuide,
    updateGuide,
    enableGuid,
    disableGuid,
    relieveGuid,
    selectIDNumber,
    guideBand,
    cancelGuid,
    listGuidesByTime
}